import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PermissionItemProps } from "apis";
import { UserItemProps } from "apis/user";

export interface AuthState {
    invalid: boolean;
    checked: boolean;
    token?: string;
    user?: UserItemProps;
    permissions: PermissionItemProps[];
}

const initialState: AuthState = {
    invalid: true,
    checked: false,
    token: localStorage.getItem("token") || undefined,
    permissions: []
};
export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        authChecked: (
            state,
            action: PayloadAction<{
                token?: string;
                user?: UserItemProps;
                permissions?: PermissionItemProps[];
            }>
        ) => {
            state.checked = true;
            if (action.payload.user && action.payload.token) {
                state.invalid = false;
                state.token = action.payload.token;
                state.user = action.payload.user;
                state.permissions = action.payload.permissions || []
            }
        },
        authUpdatePermission: (
            state,
            action: PayloadAction<{
                permissions?: PermissionItemProps[];
            }>
        ) => {
            state.permissions = action.payload.permissions || state.permissions
        },
        authLoginSuccess: (
            state,
            action: PayloadAction<{
                token: string;
                user?: UserItemProps;
                permissions?: PermissionItemProps[];
            }>
        ) => {
            state.checked = true;
            if (action.payload.user && action.payload.token) {
                state.invalid = false;
                state.token = action.payload.token;
                state.user = action.payload.user;
                localStorage.setItem("token", action.payload.token);
                state.permissions = action.payload.permissions || []
            }
        },
        authLogout: (state) => {
            state.invalid = true;
            state.checked = true;
            state.token = undefined;
            state.permissions = []
            localStorage.removeItem("token");
        },
    },
});

export const { authLoginSuccess, authChecked, authLogout, authUpdatePermission } = authSlice.actions;
export default authSlice.reducer;
